export default "<span class=\"icon\">\n  <img [src]=\"iconUrl\" style=\"height: 20px;  width: 20px;  margin-right: 10px;\">\n  <span>{{asset}}</span>\n</span>";